import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDarkLight = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g>
      <g>
        <path d='M12 6.58999C9.01 6.58999 6.58 9.01999 6.58 12.01C6.58 15 9.01 17.43 12 17.43V6.58999Z' fill='' />
        <path
          d='M12 17.42V16.42C14.44 16.42 16.42 14.44 16.42 12C16.42 9.55999 14.44 7.57999 12 7.57999V6.57999C14.99 6.57999 17.42 9.00999 17.42 12C17.42 14.99 14.99 17.42 12 17.42Z'
          fill=''
        />
        <path
          d='M12 4.83999C11.72 4.83999 11.5 4.61999 11.5 4.33999V2.60999C11.5 2.32999 11.72 2.10999 12 2.10999C12.28 2.10999 12.5 2.32999 12.5 2.60999V4.33999C12.5 4.61999 12.28 4.83999 12 4.83999Z'
          fill=''
        />
        <path
          d='M12 21.89C11.72 21.89 11.5 21.67 11.5 21.39V19.66C11.5 19.38 11.72 19.16 12 19.16C12.28 19.16 12.5 19.38 12.5 19.66V21.39C12.5 21.67 12.28 21.89 12 21.89Z'
          fill=''
        />
        <path
          d='M21.44 12.55H19.71C19.43 12.55 19.21 12.33 19.21 12.05C19.21 11.77 19.43 11.55 19.71 11.55H21.44C21.72 11.55 21.94 11.77 21.94 12.05C21.94 12.33 21.72 12.55 21.44 12.55Z'
          fill=''
        />
        <path
          d='M4.29 12.55H2.56C2.28 12.55 2.06 12.33 2.06 12.05C2.06 11.77 2.28 11.55 2.56 11.55H4.29C4.57 11.55 4.79 11.77 4.79 12.05C4.79 12.33 4.57 12.55 4.29 12.55Z'
          fill=''
        />
        <path
          d='M18.65 19.19C18.52 19.19 18.39 19.14 18.3 19.04L17.08 17.82C16.88 17.62 16.88 17.31 17.08 17.11C17.28 16.91 17.59 16.91 17.79 17.11L19.01 18.33C19.21 18.53 19.21 18.84 19.01 19.04C18.91 19.14 18.78 19.19 18.66 19.19H18.65Z'
          fill=''
        />
        <path
          d='M6.52 7.06999C6.39 7.06999 6.26 7.01999 6.17 6.91999L4.95 5.69999C4.75 5.49998 4.75 5.18999 4.95 4.98999C5.15 4.78999 5.46 4.78999 5.66 4.98999L6.88 6.20999C7.08 6.40999 7.08 6.71999 6.88 6.91999C6.78 7.01999 6.65 7.06999 6.53 7.06999H6.52Z'
          fill=''
        />
        <path
          d='M5.36 19.2C5.23 19.2 5.1 19.15 5.01 19.05C4.81 18.85 4.81 18.54 5.01 18.34L6.23 17.12C6.43 16.92 6.74 16.92 6.94 17.12C7.14 17.32 7.14 17.63 6.94 17.83L5.72 19.05C5.62 19.15 5.49 19.2 5.37 19.2H5.36Z'
          fill=''
        />
        <path
          d='M17.48 7.06999C17.35 7.06999 17.22 7.01999 17.13 6.91999C16.93 6.71999 16.93 6.40999 17.13 6.20999L18.36 4.98999C18.56 4.78999 18.87 4.78999 19.07 4.98999C19.27 5.18999 19.27 5.49998 19.07 5.69999L17.84 6.91999C17.74 7.01999 17.61 7.06999 17.49 7.06999H17.48Z'
          fill=''
        />
      </g>
    </g>
  </svg>
);
export default SvgDarkLight;
